import dayjs from "dayjs";
import { OrderModel } from "../../../screens/portfolio-info/types/OrderModel";
import { AssetType } from "../../types/AssetType";
import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import { BaseCalculationService } from "./BaseCalculationService";

export class GammaCalculationService extends BaseCalculationService {
    protected calculateForFutures(_: OrderModel): number {
        return 0;
    }

    protected calculateForOption(order: OrderModel,
        underlyingPrice: number, timeToExpirationInShareOfYear: number
    ): number {
        const isExpired = order.expireAt !== null
            ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(order.expireAt, dayjs().toDate()) < 0
            : true;

        if (isExpired) {
            // todo: calc option price after expiration
            return 0;
        }
        
        if (order.markImpliedVolatility === null) {
            throw new Error("ImpliedVolatility cannot be null!");
        }

        if (order.strike === null) {
            throw new Error("Order property 'strike' is null.")
        }
        
        return blackScholesModelCalculationService.getGamma(
            underlyingPrice, order.strike, timeToExpirationInShareOfYear, order.markImpliedVolatility);
    }

    protected getMinTimeToExpirationInShareOfYear(): number {
        return 1 / 365;
    }
}